import React, { createContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Vector3 } from "three";
import Layout from './Utiliz/Layout';
import ErrorBoundary from './Utiliz/ErrorBoundary';
import store from './Redux/store';
import { LanguageProvider } from './Utiliz/LanguageContext';
//bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css'
//bootstrap js
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { LoadingProvider } from './Utiliz/LoadingContext';

export const MyContext = createContext();

function App() {
  const initialLabels = [{ point3D: new Vector3(0, 0, 0) }];
  const [labels, setLabels] = useState(initialLabels);
  const [label_name, set_label_name] = useState('');

  return (
    <Provider store={store}>
      <MyContext.Provider value={{ labels, setLabels, label_name, set_label_name }}>
        <div className="App">
          <ErrorBoundary>
            <LanguageProvider>
              <LoadingProvider>
                <Router basename='/merihand'>
                  <Routes>
                    <Route path='/*' element={<Layout />} />
                  </Routes>
                </Router>
              </LoadingProvider>
            </LanguageProvider>
          </ErrorBoundary>
        </div>
      </MyContext.Provider>
    </Provider>
  );
}

export default App;
